import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { trigger, transition, style, animate } from '@angular/animations';


@Component({
  selector: 'app-dialog-notification',
  templateUrl: './dialog-notification.component.html',
  styleUrls: ['./dialog-notification.component.scss'],
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ transform: 'translateY(100%)' }), 
        animate('300ms ease-out', style({ transform: 'translateY(0)' })) 
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateY(100%)' }))
      ])
    ])
  ]
})
export class DialogNotificationComponent {
  constructor(public dialogRef: MatDialogRef<DialogNotificationComponent>) {}

  openApp(): void {
    this.dialogRef.close();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  redirectToAppStore() {
    const fallbackUrlIOS = 'https://apps.apple.com/us/app/auto-arremate-exchange/id1488979731?l=pt-BR';
    const fallbackUrlAndroid = 'https://play.google.com/store/apps/details?id=br.com.actionlabs.autoarremate&hl=pt_BR&pli=1';

    const isAndroid = /android/.test(window.navigator.userAgent.toLowerCase());
    const isIOS = /iphone|ipod/.test(window.navigator.userAgent.toLowerCase());

    if (isIOS) {
      window.location.href = fallbackUrlIOS;
    } else if (isAndroid) {
      window.location.href = fallbackUrlAndroid;
    }
  }
}
